// import HomeCognito from './Home'
import UserAdministrationDesktop from "./UserAdministrationDesktop/UserAdministrationDesktop"

export default function UserAdministration() {
  return <UserAdministrationDesktop />
}
